import {
	GroupedTimetableByVehicle,
	GroupedTimetableByVehicleWithStopConnection,
	StopConnection,
} from '@/new-transport/_models/transport-timetable.model';
import { findStopConnection } from '@/new-transport/_utils/findStopConnection/find-stop-connection';

/**
 * Adds stop connections to each item in the timetable by pairing consecutive stops.
 *
 * @param {GroupedTimetableByVehicle} item - The grouped timetable for a vehicle, containing stop data without connections.
 * @param {StopConnection[]} stopConnections - Array of stop connections that define links between different stops.
 * @returns {GroupedTimetableByVehicleWithStopConnection} The grouped timetable with added stop connections between consecutive stops.
 */
export const addStopConnectionsToTimetable = (
	item: GroupedTimetableByVehicle,
	stopConnections: StopConnection[],
): GroupedTimetableByVehicleWithStopConnection => {
	const timetableWithStopConnection = item.timetable.map((v, index) => {
		const nextTimetableItem = item.timetable[index + 1];
		const stopConnection = nextTimetableItem
			? (findStopConnection(stopConnections, v.stop.id, nextTimetableItem.stop.id) ?? null)
			: null;

		return { ...v, stopConnection };
	});

	return { ...item, timetable: timetableWithStopConnection };
};
